import { getAccountsSummaryCount } from "../types/admin_analytics_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function adminAnalyticsReducer(state = initState, action = {}) {
  switch (action.type) {
    case getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
